/* IMPORT MODULE */
import React, { useState, useEffect, useLayoutEffect } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Container, Row, Col, Button } from "react-bootstrap";

/* IMPORT UTILS */
import { emptyImage, getCloudImageUrl } from "../../utils";
import {
  DEFAULT_PAYMENT_METHOD,
  BANKTRANSFER,
  VIRTUALACCOUNT,
  BCA_VA,
  BNI_VA,
  BRI_VA,
  PERMATA_VA,
  MANDIRI_VA,
  CREDITCARD,
  BCA_CREDIT_CARD,
  MANDIRI_CREDIT_CARD,
  BCA_INSTALLMENTS,
  KREDIVO,
  ATOME,
  AKULAKU,
  GOPAY,
  FULLWALLET,
  INSTALLMENTS,
} from "../../constants/paymentMethods";

/* */
import { getShoppingCartList } from "../../actions/shoppingCartAction";

/* IMPORT IMAGE */
import CloseButton from "../../images/bag-delete.png";
import PlusButton from "../../images/bag-plus.png";
import MinusButton from "../../images/minus.png";
import PinAddress from "../../images/pin-address.png";
import ContinueArrow from "../../images/shopping-cart-continue.png";
import BackArrow from "../../images/shopping-cart-back.png";
import ArrowsNext from "../../images/arrowsNext.png";
import CircleBack from "../../images/circle-back.png";

/* DEKSTOP VIEW COMPONENT */
const ShoppingCartDekstopView = () => {
  return (
    <Container fluid id="shopping-cart-page-first-wrapper-dekstop-view">
      <Row className="shopping-cart-page-second-wrapper">
        <Col className="left-bag-content">
          <Row className="left-bag-top-section-shopping-bag">
            <Row className="shopping-bag-title-wrapper">
              <h3 className="left-bag-top-section-shopping-bag-title">
                Shopping Bag
              </h3>
            </Row>
            <Row className="shopping-bag-item-card-list-wrapper">
              {/* MAIN PRODUCT ITEM */}
              <Row className="shopping-bag-item-card">
                <Col className="green-round-close-icon">
                  <KickImage src={CloseButton} alt="..." />
                </Col>
                <Row className="shopping-bag-item-wrapper">
                  <Col className="shopping-bag-item-card-image-wrapper">
                    <KickImage src={emptyImage("sneakers")} alt="..." />
                  </Col>
                  <Col className="shopping-bag-item-card-description-wrapper">
                    <p>Nike Air Max 270 React Black Iron Grey University Red</p>
                    <p>
                      US 8 / Pre-Owned, Missing Accessories, Discoloration,
                      Sratches, Transfered Color, Sign Of Wear
                    </p>
                    <p>IDR 8.000.000</p>
                  </Col>
                </Row>
              </Row>

              {/* ADD ONS ITEM */}
              <Row className="shopping-bag-item-card">
                <Row className="shopping-bag-item-wrapper">
                  <Col className="shopping-bag-item-card-image-wrapper">
                    <KickImage src={emptyImage("sneakers")} alt="..." />
                  </Col>
                  <Col className="shopping-bag-item-card-description-wrapper">
                    <p>Umbre Waterproof Spray</p>
                    <p>
                      Umbre x Kick Avenue Waterproof Spray 75 ml + free shipping
                    </p>
                    <p>IDR 8.000.000</p>
                  </Col>
                </Row>
                <Row className="add-on-increase-decrease-wrapper">
                  <Col className="adds-on-icon adds-on-minus-icon">
                    <KickImage src={MinusButton} alt="..." />
                  </Col>
                  <Col className="adds-on-amount-text">
                    <p>1</p>
                  </Col>
                  <Col className="adds-on-icon adds-on-plus-icon">
                    <KickImage src={PlusButton} alt="..." />
                  </Col>
                </Row>
              </Row>
            </Row>
          </Row>
          <Row className="left-bag-bottom-section-extra-item">
            <Row className="extra-item-shopping-bag-title-wrapper">
              <h3 className="left-bag-bottom-section-shopping-bag-title">
                Extra Love for your purchase
              </h3>
            </Row>
            <Row className="extra-love-item-card-list-wrapper">
              <Col className="extra-love-item-card">
                <Col className="shopping-cart-extra-item-image-wrapper">
                  <KickImage src={emptyImage("electronics-collectibles")} alt="..." />
                </Col>
                <Col className="extra-item-card-description">
                  <p>Umbre Waterproof Spray</p>
                  <p>
                    Umbre x Kick Avenue Waterproof Spray 75 ml + free shipping
                  </p>
                  <p
                    style={{
                      fontWeight: "bold",
                      color: "#159953",
                    }}
                  >
                    IDR 150.000
                  </p>
                  <KickImage
                    className="extra-item-add-button-icon"
                    src={PlusButton}
                    alt="..."
                  />
                </Col>
              </Col>
            </Row>
          </Row>
        </Col>
        <Col className="right-bag-content">
          <Row className="right-bag-content-section-wrapper right-bag-address-section">
            <Col className="shopping-cart-address-section-image-container">
              <KickImage src={PinAddress} alt="..." />
            </Col>
            <Col className="shopping-cart-address-section-description-container">
              <p>Deliver to</p>
              <p>Rumah - Sarah Amita</p>
              <p>Jalan Merpati No 178, Depok, Jawa Barat 16722</p>
            </Col>
          </Row>
          <Row className="right-bag-content-section-wrapper right-bag-voucher-section">
            <Row className="right-bag-voucher-section-title">
              <p>Have a voucher code?</p>
            </Row>
            <Row className="right-bag-voucher-section-content">
              <Col className="right-bag-voucher-text">
                <p>You have vouchers available</p>
              </Col>
              <Button className="right-bag-voucher">
                <p>View my vouchers</p>
              </Button>
            </Row>
          </Row>
          <Row className="right-bag-content-section-wrapper right-bag-summary-wrapper">
            <Row className="right-bag-content-summary-row">
              <p>Payment Summary</p>
            </Row>
            <Row className="right-bag-content-summary-row">
              <p>Total Order</p>
              <p>IDR. 4.750.000</p>
            </Row>
            <Row className="right-bag-content-summary-row">
              <p>Administration Fee</p>
              <p>IDR. 0</p>
            </Row>
            <Row className="right-bag-content-summary-row">
              <p>Shipping &#38; Handling</p>
              <p>IDR. 68.000</p>
            </Row>
            <Row className="right-bag-content-summary-row">
              <p>Voucher Code</p>
              <p>IDR. 0</p>
            </Row>
            <Row className="right-bag-content-summary-row">
              <p>
                Discount&#40;<span>Automatically applied</span>&#41;
              </p>
              <p>IDR. 0</p>
            </Row>
            <Row className="right-bag-content-summary-row">
              <p>Promo Product</p>
              <p>IDR. 0</p>
            </Row>
            <Row className="right-bag-content-summary-row">
              <p>Total</p>
              <p>IDR. 4.818.000</p>
            </Row>
            <Row className="right-bag-content-summary-row">
              <p>By clicking Continue, user has read and</p>
              <p>
                agreed to <u>Kick Avenue Terms and Conditions</u>
              </p>
            </Row>
            <Row className="right-bag-content-summary-button">
              <Button>
                <KickImage src={BackArrow} alt="..." />
                <p>Shop some more</p>
              </Button>
              <Button>
                <p>Continue</p>
                <KickImage src={ContinueArrow} alt="..." />
              </Button>
            </Row>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

/* MAX WIDTH 1024px VIEW COMPONENT */
const ShoppingCartResponsiveView = () => {
  return (
    <Container fluid id="shopping-cart-page-first-wrapper-responsive-view">
      <Row className="shopping-cart-page-second-wrapper">
        <Col className="responsive-top-bag-content">
          <div className="responsive-per-section-wrapper">
            <Row className="responsive-top-bag-title">
              <p>Shopping Bag</p>
            </Row>
          </div>
          <div className="responsive-per-section-wrapper">
            <Row className="responsive-top-bag-content-section-wrapper responsive-top-bag-address-section responsive-address-section">
              <Col className="shopping-cart-address-section-image-container">
                <KickImage src={PinAddress} alt="..." />
              </Col>
              <Col className="shopping-cart-address-section-description-container">
                <p>Deliver to</p>
                <p>Rumah - Sarah Amita</p>
                <p>Jalan Merpati No 178, Depok, Jawa Barat 16722</p>
              </Col>
            </Row>
          </div>
          <div className="responsive-per-section-wrapper">
            <Row className="responsive-top-bag-content-section-wrapper right-bag-voucher-section responsive-voucher-section">
              <Row className="right-bag-voucher-section-title">
                <p>Have a voucher code?</p>
              </Row>
              <Row className="right-bag-voucher-section-content">
                <Col className="right-bag-voucher-text">
                  <p>You have vouchers available</p>
                </Col>
                <Button className="right-bag-voucher">
                  <p>View my vouchers</p>
                </Button>
              </Row>
            </Row>
          </div>
        </Col>
        <Col className="responsive-bottom-bag-content">
          <div className="responsive-shopping-bag-item-section">
            <Row className="left-bag-top-section-shopping-bag">
              <Row className="shopping-bag-item-card-list-wrapper">
                {/* MAIN PRODUCT ITEM */}
                <Row className="shopping-bag-item-card">
                  <Col className="green-round-close-icon">
                    <KickImage src={CloseButton} alt="..." />
                  </Col>
                  <Row className="shopping-bag-item-wrapper">
                    <Col className="shopping-bag-item-card-image-wrapper">
                      <KickImage src={emptyImage("sneakers")} alt="..." />
                    </Col>
                    <Col className="shopping-bag-item-card-description-wrapper">
                      <p>
                        Nike Air Max 270 React Black Iron Grey University Red
                      </p>
                      <p>
                        US 8 / Pre-Owned, Missing Accessories, Discoloration,
                        Sratches, Transfered Color, Sign Of Wear
                      </p>
                      <p>IDR 8.000.000</p>
                    </Col>
                  </Row>
                </Row>

                {/* ADD ONS ITEM */}
                <Row className="shopping-bag-item-card">
                  <Row className="shopping-bag-item-wrapper">
                    <Col className="shopping-bag-item-card-image-wrapper">
                      <KickImage src={emptyImage("sneakers")} alt="..." />
                    </Col>
                    <Col className="shopping-bag-item-card-description-wrapper">
                      <p>Umbre Waterproof Spray</p>
                      <p>
                        Umbre x Kick Avenue Waterproof Spray 75 ml + free
                        shipping
                      </p>
                      <p>IDR 8.000.000</p>
                    </Col>
                  </Row>
                  <Row className="add-on-increase-decrease-wrapper">
                    <Col className="adds-on-icon adds-on-minus-icon">
                      <KickImage src={MinusButton} alt="..." />
                    </Col>
                    <Col className="adds-on-amount-text">
                      <p>1</p>
                    </Col>
                    <Col className="adds-on-icon adds-on-plus-icon">
                      <KickImage src={PlusButton} alt="..." />
                    </Col>
                  </Row>
                </Row>
              </Row>
            </Row>
          </div>
          <div className="responsive-shopping-bag-item-section">
            <Row className="left-bag-bottom-section-extra-item">
              <Row className="extra-item-shopping-bag-title-wrapper">
                <h3 className="left-bag-bottom-section-shopping-bag-title">
                  Extra Love for your purchase
                </h3>
              </Row>
              <Row className="extra-love-item-card-list-wrapper">
                {Array(8)
                  .fill(null)
                  .map(() => {
                    return (
                      <Col className="extra-love-item-card">
                        <Col className="shopping-cart-extra-item-image-wrapper">
                          <KickImage src={emptyImage("electronics-collectibles")} alt="..." />
                        </Col>
                        <Col className="extra-item-card-description">
                          <p>Umbre Waterproof Spray</p>
                          <p>
                            Umbre x Kick Avenue Waterproof Spray 75 ml + free
                            shipping
                          </p>
                          <p
                            style={{
                              fontWeight: "bold",
                              color: "#159953",
                            }}
                          >
                            IDR 150.000
                          </p>
                          <KickImage
                            className="extra-item-add-button-icon"
                            src={PlusButton}
                            alt="..."
                          />
                        </Col>
                      </Col>
                    );
                  })}
              </Row>
            </Row>
          </div>
        </Col>
        <Col className="responsive-top-bag-content responsive-summary-wrapper">
          <div className="responsive-per-section-wrapper">
            <Row className="responsive-top-bag-content-section-wrapper right-bag-summary-wrapper responsive-summary-section">
              <Row className="right-bag-content-summary-row">
                <p>Payment Summary</p>
              </Row>
              <Row className="right-bag-content-summary-row">
                <p>Total Order</p>
                <p>IDR. 4.750.000</p>
              </Row>
              <Row className="right-bag-content-summary-row">
                <p>Administration Fee</p>
                <p>IDR. 0</p>
              </Row>
              <Row className="right-bag-content-summary-row">
                <p>Shipping &#38; Handling</p>
                <p>IDR. 68.000</p>
              </Row>
              <Row className="right-bag-content-summary-row">
                <p>Voucher Code</p>
                <p>IDR. 0</p>
              </Row>
              <Row className="right-bag-content-summary-row">
                <p>
                  Discount&#40;<span>Automatically applied</span>&#41;
                </p>
                <p>IDR. 0</p>
              </Row>
              <Row className="right-bag-content-summary-row">
                <p>Promo Product</p>
                <p>IDR. 0</p>
              </Row>
              <Row className="right-bag-content-summary-row">
                <p>By clicking Continue, user has read and</p>
                <p>
                  agreed to <u>Kick Avenue Terms and Conditions</u>
                </p>
              </Row>
            </Row>
          </div>
          <div className="responsive-per-section-wrapper responsive-summary-section-wrapper">
            <Row className="responsive-top-bag-content-section-wrapper right-bag-summary-wrapper responsive-summary-section">
              <Row className="right-bag-content-summary-row">
                <p>Total</p>
                <p>IDR. 4.818.000</p>
              </Row>
              <Row className="right-bag-content-summary-button">
                <Button>
                  <KickImage src={BackArrow} alt="..." />
                  <p>Shop some more</p>
                </Button>
                <Button>
                  <p>Choose Payment</p>
                  <KickImage src={ContinueArrow} alt="..." />
                </Button>
              </Row>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

/* CHOOSE PAYMENT COMPONENT */
const ChoosePaymentProccess = () => {
  return (
    <Container
      fluid
      id="shopping-cart-page-first-wrapper-choose-payment-process"
    >
      <Row className="shopping-cart-page-second-wrapper">
        <Col className="left-bag-content">
          <div className="scroll-wrapper">
            <Row className="left-bag-top-section-shopping-bag">
              <Row className="shopping-bag-title-wrapper">
                <h3 className="left-bag-top-section-shopping-bag-title">
                  Shopping Bag
                </h3>
              </Row>
              <Row className="shopping-bag-item-card-list-wrapper">
                {/* MAIN PRODUCT ITEM */}
                <Row className="shopping-bag-item-card">
                  <Row className="shopping-bag-item-wrapper">
                    <Col className="shopping-bag-item-card-image-wrapper">
                      <KickImage src={emptyImage("sneakers")} alt="..." />
                    </Col>
                    <Col className="shopping-bag-item-card-description-wrapper">
                      <div className="desc-wrapper">
                        <p>
                          Nike Air Max 270 React Black Iron Grey University Red
                        </p>
                        <p>
                          US 8 / Pre-Owned, Missing Accessories, Discoloration,
                          Sratches, Transfered Color, Sign Of Wear
                        </p>
                      </div>
                      <div className="price-quantity-wrapper">
                        <p>IDR 8.000.000</p>
                      </div>
                    </Col>
                  </Row>
                </Row>

                {/* ADD ONS ITEM */}
                <Row className="shopping-bag-item-card">
                  <Row className="shopping-bag-item-wrapper">
                    <Col className="shopping-bag-item-card-image-wrapper">
                      <KickImage src={emptyImage("sneakers")} alt="..." />
                    </Col>
                    <Col className="shopping-bag-item-card-description-wrapper">
                      <div className="desc-wrapper">
                        <p>Umbre Waterproof Spray</p>
                        <p>
                          Umbre x Kick Avenue Waterproof Spray 75 ml + free
                          shipping
                        </p>
                      </div>
                      <div className="price-quantity-wrapper">
                        <p>IDR 8.000.000</p>
                        <p>Qty: 1</p>
                      </div>
                    </Col>
                  </Row>
                </Row>
              </Row>
            </Row>
            <Row className="left-bag-bottom-section-extra-item">
              <Row className="right-bag-content-section-wrapper right-bag-summary-wrapper">
                <Row className="right-bag-content-summary-row">
                  <p>Order Summary</p>
                </Row>
                <Row className="right-bag-content-summary-row">
                  <p>Total Order</p>
                  <p>IDR. 4.750.000</p>
                </Row>
                <Row className="right-bag-content-summary-row">
                  <p>Administration Fee</p>
                  <p>IDR. 0</p>
                </Row>
                <Row className="right-bag-content-summary-row">
                  <p>Shipping &#38; Handling</p>
                  <p>IDR. 68.000</p>
                </Row>
                <Row className="right-bag-content-summary-row">
                  <p>Voucher Code</p>
                  <p>IDR. 0</p>
                </Row>
                <Row className="right-bag-content-summary-row">
                  <p>
                    Discount&#40;<span>Automatically applied</span>&#41;
                  </p>
                  <p>IDR. 0</p>
                </Row>
                <Row className="right-bag-content-summary-row">
                  <p>Promo Product</p>
                  <p>IDR. 0</p>
                </Row>
                <Row className="right-bag-content-summary-row">
                  <p>Total</p>
                  <p>IDR. IDR. 4.818.000</p>
                </Row>
              </Row>
            </Row>
          </div>
        </Col>
        <Col className="right-bag-content">
          {false && (
            <div className="payment-list-scroll">
              <Row className="choose-payment-type">
                <Col className="icon-wrapper">
                  <KickImage src={CircleBack} alt="..." />
                </Col>
                <Col className="text">
                  <p>Choose Payment</p>
                </Col>
              </Row>
              <Row className="amount-to-be-paid">
                <p>Amount to be paid</p>
                <p>IDR. 4.968.000</p>
              </Row>
              <Row className="kick-credit-payment-wrapper">
                <div className="title-text-wrapper">
                  <p>Kick Credit</p>
                  <p>
                    Your payment will be verified automatically by the payment
                    gateway.
                  </p>
                </div>
                <Row className="payment-list-wrapper kick-credit-wrapper">
                  {DEFAULT_PAYMENT_METHOD.map((item) => {
                    if (item.payment_group === 3) {
                      return (
                        <>
                          <Col className="icon-wrapper">
                            <KickImage src={getCloudImageUrl(item.logo)} alt="..." />
                          </Col>
                          <Col className="text-wrapper">
                            <p>Kick Credit</p>
                            <p>Balance : RP 15.000.000.000</p>
                          </Col>
                          <Col className="arrow-wrapper">
                            <KickImage src={ArrowsNext} alt="..." />
                          </Col>
                        </>
                      );
                    }
                  })}
                </Row>
              </Row>
              <Row className="kick-credit-payment-wrapper">
                <div className="title-text-wrapper">
                  <p>Installment</p>
                  <p>
                    Your payment will be verified automatically by the payment
                    gateway.
                  </p>
                </div>
                {DEFAULT_PAYMENT_METHOD.map((item) => {
                  if (item.payment_group === 1) {
                    return (
                      <Row className="payment-list-wrapper virtual-account-wrapper">
                        <Col className="icon-wrapper">
                          {item.logo && (
                            <KickImage src={getCloudImageUrl(item.logo)} alt="..." />
                          )}
                        </Col>
                        <Col className="text-wrapper">
                          <p>{item.label}</p>
                        </Col>
                        <Col className="arrow-wrapper">
                          <KickImage src={ArrowsNext} alt="..." />
                        </Col>
                      </Row>
                    );
                  }
                })}
              </Row>
              <Row className="kick-credit-payment-wrapper">
                <div className="title-text-wrapper">
                  <p>Installment</p>
                  <p>
                    Your payment will be verified automatically by the payment
                    gateway.
                  </p>
                </div>
                {DEFAULT_PAYMENT_METHOD.map((item) => {
                  if (item.payment_group === 2) {
                    return (
                      <Row className="payment-list-wrapper virtual-account-wrapper">
                        <Col className="icon-wrapper">
                          {item.logo && (
                            <KickImage src={getCloudImageUrl(item.logo)} alt="..." />
                          )}
                        </Col>
                        <Col className="text-wrapper">
                          <p>{item.label}</p>
                        </Col>
                        <Col className="arrow-wrapper">
                          <KickImage src={ArrowsNext} alt="..." />
                        </Col>
                      </Row>
                    );
                  }
                })}
              </Row>
            </div>
          )}

          {/* WAITING PAYMENT 1 */}
          {false && (
            <div className="waiting-payment-1">
              <Row>
                <p>
                  ORD ID <u>IKA-O50221_ANX-ZF6</u>
                </p>
              </Row>
              <Row>
                <p>Waiting you payment confirmation</p>
                <div className="clock-icon-wrapper"></div>
                <p className="paid-countdown">00 : 57 : 59</p>
                <p>Please complete your payment before</p>
                <p>Friday, February 1, 2021 03:27</p>
              </Row>
              <Row>
                <div className="copy-amount-wrapper">
                  <div className="copy-text-wrapper">
                    <p>Amount to be paid</p>
                    <p>IDR. 4.968.000</p>
                  </div>
                  <div className="copy-icon-wrapper"></div>
                </div>
              </Row>
              <Row>
                <p>If you have any questions about your order,</p>
                <p>
                  please contact our team by email to{" "}
                  <u>info@kickavenue.com.</u>
                </p>
                <p>Please put your invoice number into your subject email.</p>
              </Row>
              <Row>
                <p>Continue to payment</p>
                <KickImage src={ContinueArrow} alt="..." />
              </Row>
            </div>
          )}

          {/* WAITING PAYMENT 2 */}
          {false && (
            <div className="waiting-payment-2">
              <Row>
                <p>Thank you, we have received your order</p>
                <p>
                  ORD ID <u>IKA-O50221_ANX-ZF6</u>
                </p>
              </Row>
              <Row>
                <p>Waiting you payment confirmation</p>
                <div className="clock-icon-wrapper"></div>
                <p className="paid-countdown">00 : 57 : 59</p>
                <p>Please complete your payment before</p>
                <p>Friday, February 1, 2021 03:27</p>
              </Row>
              <Row>
                <div className="copy-amount-wrapper">
                  <div className="copy-text-wrapper">
                    <p>Amount to be paid</p>
                    <p>IDR. 4.968.000</p>
                  </div>
                  <div className="copy-icon-wrapper"></div>
                </div>
                <div className="copy-amount-wrapper">
                  <div className="copy-text-wrapper">
                    <p>Payment Virtual Account - Mandiri</p>
                    <p>70012 320907873220</p>
                  </div>
                  <div className="copy-icon-wrapper"></div>
                </div>
              </Row>
              <Row>
                <p>If you have any questions about your order,</p>
                <p>
                  please contact our team by email to{" "}
                  <u>info@kickavenue.com.</u>
                </p>
                <p>Please put your invoice number into your subject email.</p>
              </Row>
              <Row>
                <Button className="see-instruction-btn">
                  <p>See Instructions</p>
                </Button>
                <Button className="go-to-buying-btn">
                  <p>Continue to payment</p>
                  <KickImage src={ContinueArrow} alt="..." />
                </Button>
              </Row>
            </div>
          )}

          {/* Confirm Payment VA */}
          <div className="confirm-payment-va">
            <div className="tbp-and-payment-card">
              <Row className="conf-va-amount-tbp">
                <p>Amount to be paid</p>
                <p>IDR. 4.968.000</p>
              </Row>
              <Row className="payment-method-card-wrapper">
                <div className="title-wrapper">
                  <p>Payment Method</p>
                </div>
                <Row className="payment-card">
                  <Col className="icon-wrapper">
                    {DEFAULT_PAYMENT_METHOD[1].logo && (
                      <KickImage src={getCloudImageUrl(DEFAULT_PAYMENT_METHOD[1].logo)} alt="..." />
                    )}
                  </Col>
                  <Col className="text-wrapper">
                    <p>{DEFAULT_PAYMENT_METHOD[1].label}</p>
                  </Col>
                </Row>
              </Row>
            </div>
            <div className="confirm-payment-btn-wrapper">
              <Button className="back-btn confirm-button">
                <KickImage src={BackArrow} alt="..." />
                <p>Back</p>
              </Button>
              <Button className="continue-btn confirm-button">
                <p>Continue</p>
                <KickImage src={ContinueArrow} alt="..." />
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

function PageShoppingCart() {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    setWidth(window.innerWidth);
    getShoppingCartList();
  }, []);

  useLayoutEffect(() => {
    const updateSize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", updateSize);
  });

  if (width > 1024) return <ShoppingCartDekstopView />;
  return <ShoppingCartResponsiveView />;

  // return <ChoosePaymentProccess />;
}

const mapDispatchToProps = {
  getShoppingCartList: getShoppingCartList,
};

export default connect(null, mapDispatchToProps)(PageShoppingCart);
